import { viewportHeight as layoutViewportHeight } from "../../utils/displayDensity";
import { SkeletonBox } from "../skeletons/SkeletonLoader";
import { useState, useEffect } from "react";

const SkeletonPageAccessTable = ({
  permissionCount = 3,
  rowCount = 5,
  styles,
}) => {
  const [visibleRowCount, setVisibleRowCount] = useState(rowCount);

  const calculateVisibleRows = () => {
    const ROW_HEIGHT = 50;
    const HEADER_HEIGHT = 120;
    const FOOTER_HEIGHT = 40;

    const availableHeight = layoutViewportHeight() - HEADER_HEIGHT - FOOTER_HEIGHT;
    const rowsThatFit = Math.max(1, Math.floor(availableHeight / ROW_HEIGHT));

    return rowsThatFit + 1;
  };

  useEffect(() => {
    const handleResize = () => {
      setVisibleRowCount(calculateVisibleRows());
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <table style={styles.table}>
      <thead>
        <tr>
          <th style={styles.thLeft}>
            <SkeletonBox width="80px" height={16} />
          </th>
          <th style={styles.thLeft}>
            <SkeletonBox width="120px" height={16} />
          </th>
          <th style={styles.thCenter}>
            <div style={styles.centerContent}>
              <SkeletonBox width="80px" height={16} />
            </div>
          </th>
          <th style={styles.thCenter}>
            <div style={styles.centerContent}>
              <SkeletonBox width="120px" height={16} />
            </div>
          </th>
          {Array.from({ length: permissionCount }).map((_, index) => (
            <th key={`skeleton-header-${index}`} style={styles.thCenter}>
              <div style={styles.centerContent}>
                <SkeletonBox width="60px" height={16} />
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: visibleRowCount }).map((_, rowIndex) => (
          <tr key={`skeleton-row-${rowIndex}`}>
            <td style={styles.td}>
              <SkeletonBox width="100px" height={14} />
            </td>
            <td style={styles.td}>
              <SkeletonBox width="160px" height={14} />
            </td>
            <td style={styles.tdCenter}>
              <div style={styles.centerContent}>
                <SkeletonBox width="100px" height={14} />
              </div>
            </td>
            <td style={styles.tdCenter}>
              <div style={styles.centerContent}>
                <SkeletonBox width="160px" height={14} />
              </div>
            </td>
            {Array.from({ length: permissionCount }).map((_, colIndex) => (
              <td
                key={`skeleton-cell-${rowIndex}-${colIndex}`}
                style={styles.tdCenter}
              >
                <div style={styles.centerContent}>
                  <SkeletonBox width="16px" height="16px" borderRadius="4px" />
                </div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SkeletonPageAccessTable;
